import { render } from "./FieldsModal.vue?vue&type=template&id=b3333cd8&scoped=true&ts=true"
import script from "./FieldsModal.vue?vue&type=script&lang=ts"
export * from "./FieldsModal.vue?vue&type=script&lang=ts"

import "./FieldsModal.vue?vue&type=style&index=0&id=b3333cd8&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3333cd8"]])

export default __exports__